// extracted by mini-css-extract-plugin
export default {"block":"NotBlock_block__tuNdd","void":"NotBlock_void__hv24b"};